import {
  EyeInvisibleOutlined,
  EyeOutlined,
  LockOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useEffect, useState } from "react";
import { forceRefresh } from "../lib/functions";
import { MInput } from "./elements/mInputs";
import packageJson from "../../package.json";
import { CredentialsHandler, DOMAIN } from "../lib/lib";
import { UserInfo } from "@ckal-software/ckal-lib";
import { useNotifcation } from "../lib/hooks/useNotification";
import css from "./loginScreen.module.css";
import { MButton } from "./elements/mbutton";

interface LoginScreenProps {
  isWorking: boolean;
  setIsWorking(isWorking: boolean): void;
  onLogin(userInfo: UserInfo): void;
}

export function LoginScreen(props: LoginScreenProps) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const notify = useNotifcation();

  useEffect(() => {
    setEmail(new URLSearchParams(window.location.search).get("email") || "");
  }, []);

  async function doLogin() {
    props.setIsWorking(true);

    try {
      await CredentialsHandler.login(email, password);

      const userInfo = await CredentialsHandler.getUserInfo();
      props.onLogin(userInfo);
    } catch (error) {
      if (error instanceof Error && error.name === "NotAuthorizedException") {
        notify("Forkert email eller kodeord");
      } else {
        notify(error instanceof Error ? error.message : String(error));
      }
    } finally {
      props.setIsWorking(false);
    }
  }

  const canSubmit = !!email && !!password && !props.isWorking;

  return (
    <div className={css.page}>
      {/* Logo area */}
      <div className={css.logoArea}>
        <div className={css.logoIcon}>🍎</div>
        <div className={css.title}>Madplanen</div>
        <div className={css.subtitle}>Log ind for at fortsætte</div>
      </div>

      {/* Form card */}
      <div className={css.card}>
        <MInput
          prefix={<UserOutlined className={css.inputIcon} />}
          value={email}
          size="large"
          style={{ flex: "none" }}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email..."
          type="email"
          className="new-item-input"
        />
        <MInput
          type={showPassword ? "text" : "password"}
          prefix={<LockOutlined className={css.inputIcon} />}
          suffix={
            password ? (
              showPassword ? (
                <EyeOutlined
                  className={css.visibilityIcon}
                  onClick={() => setShowPassword(false)}
                />
              ) : (
                <EyeInvisibleOutlined
                  className={css.visibilityIcon}
                  onClick={() => setShowPassword(true)}
                />
              )
            ) : undefined
          }
          size="large"
          style={{ flex: "none" }}
          placeholder="Kodeord..."
          value={password}
          onPressEnter={doLogin}
          onChange={(e) => setPassword(e.target.value)}
          className="new-item-input"
        />
        <div
          className={css.forgotPassword}
          onClick={() =>
            (window.location.href = `https://${DOMAIN}/forgot-password?redirect=${window.location.origin}/login`)
          }
        >
          Glemt kodeord?
        </div>

        <MButton
          type="primary"
          onClick={doLogin}
          disabled={!canSubmit}
          loading={props.isWorking}
          style={{ width: "100%", height: 48, borderRadius: 14 }}
        >
          Log ind
        </MButton>
      </div>

      {/* Sign up link */}
      <div
        className={css.signupLink}
        onClick={() =>
          (window.location.href = `https://${DOMAIN}/sign-up?redirect=${window.location.origin}/login`)
        }
      >
        Har du ikke en konto?{" "}
        <span className={css.signupHighlight}>Opret konto</span>
      </div>

      {/* Version */}
      <div className={css.version} onClick={forceRefresh}>
        v{packageJson.version}
      </div>
    </div>
  );
}
